import MuiKeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type KeyboardArrowUpProps = SvgIconProps;

export const KeyboardArrowUp = (props: KeyboardArrowUpProps) => {
  return <MuiKeyboardArrowUp {...props} />;
};
